import Button from "@mui/material/Button";

const ButtonNative = (props) => {
  return (
    <Button
      {...props}
      variant="contained"
      sx={{
        fontFamily: "SapFiori72, sans-serif",
        fontWeight: 600, // Adjust the font weight here

        backgroundColor: "#0070f2", // Adjust the background color to match Fiori's style
        color: "#ffffff", // Set text color to white for better contrast
        borderRadius: "8px", // Add rounded corners to the button
        "&:hover": {
          backgroundColor: "#0c7dff", // Darken the background color on hover
        },
      }}
    />
  );
};

export default ButtonNative;

